import projectsStructure from './projects.json';
import { translations } from '../../translations';

export interface Project {
  id: string;
  docName: string;
  folder: string;
  title: string;
  primary: string;
  secondary: string;
  logo: string;
  about: string;
  technologies: Array<{ name: string; icon: string }>;
  photos: string[];
  tags: Array<{ key: string; name: string; color: string }>;
  icon: string;
  link?: string;
}

/**
 * Get projects with translated content
 * Merges structural data from projects.json with translations
 * @param _lang - Current language (used to trigger recalculation)
 */
export function getProjects(_lang?: string): Project[] {
  return projectsStructure.map(project => {
    const title = translations(`projects_data.${project.id}.title`) || project.title;
    const about = translations(`projects_data.${project.id}.about`) || project.about;

    const tags = project.tags.map(tag => ({
      ...tag,
      name: translations(`projects_data.${project.id}.tags.${tag.key}`) || tag.name
    }));

    return {
      ...project,
      title,
      about,
      tags
    };
  });
}